<template>
  <div>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container fluid class="prediction-container-hero">
      <div class="vert-cent-high-screens">
        <b-row>
          <b-col xl="3" lg="1" md="2" sm="0" cols="0"/>
          <b-col xl="6" lg="10" md="8" sm="12" cols="12">
            <md-card class="island-card flat mb-0 ml-0" :style="labelCardStyle">
              <md-card-content style="padding: 1em">
                <b-row class="mt-3 mb-3">
                  <b-col style="text-align: center;">
                    <div style="padding:1em">
                    <img :src="labelLogo" class="label-logo" />
                    <p class="moow-header" style="padding-left:1em">{{i18n_local.free_valuation}}</p>
                    <p class="moow-info-txt secondary">{{i18n_local.valuation_hero_text}}</p>
                    </div>
                    <toggle-switch
                      :btnTitleOn="i18n_local.rent"
                      :btnTitleOff="i18n_local.sale"
                      @emitToggleOn="switchDealType"
                      :initialState="selectedDealTypeIsRent"
                    />

                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <md-autocomplete
                      class="moow-input"
                      v-model="selected"
                      md-layout="box"
                      :md-options="placesPredictions"
                      @md-changed="getPlacePredictions"
                      @md-selected="getPlaceDetails"
                    >
                      <label>{{i18n_local.property_address_tallinn}}</label>
                      <template
                        slot="md-autocomplete-item"
                        slot-scope="{ item }"
                      >{{ item.description }}</template>
                    </md-autocomplete>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col lg="4" cols="6">
                    <b-row>
                      <b-col>
                                            <md-field :class="{ 'md-invalid': nrOfRoomsErr }">
                      <label>{{i18n_local.nr_of_rooms}}</label>
                      <md-input v-model="nrOfRooms" type="number"></md-input>
                      <span class="md-error">Required</span>
                    </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                                            <md-field :class="{ 'md-invalid': floorNrErr }">
                      <label>{{i18n_local.floor_number}}</label>
                      <md-input v-model="apartmentFloor" type="number"></md-input>
                      <span class="md-error">Required</span>
                    </md-field>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="4" cols="6">
                   <b-row>
                      <b-col>
                        <md-field :class="{ 'md-invalid': areaErr }">
                          <label>{{i18n_local.area}} (m²)</label>
                          <md-input v-model="apartmentArea" type="number"></md-input>
                          <span class="md-error">Required</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field :class="{ 'md-invalid': nrOfFloorsErr }">
                          <label>{{i18n_local.nr_of_floors}}</label>
                          <md-input v-model="nrOfFloors" type="number"></md-input>
                          <span class="md-error">Required</span>
                        </md-field>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="4" cols="6">
                    <md-checkbox v-model="balcony" class="">{{i18n_local.balcony | capitalize}}</md-checkbox>
                    <md-checkbox v-model="parking" class="">{{i18n_local.parking | capitalize}}</md-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="8">
                    <md-field :class="{ 'md-invalid': conditionErr }">
                      <label for="movie">{{i18n_local.condition}}</label>
                      <md-select v-model="apartmentCondition">
                        <md-option
                          v-for="(condition, index) in conditions"
                          :key="index"
                          :value="condition.value"
                        >{{condition.text | capitalize}}</md-option>
                      </md-select>
                      <span class="md-error">Required</span>
                    </md-field>
                  </b-col>
                  <b-col cols="4"></b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col style="text-align:center">
                     <moow-button :type="['dark']" :btnText="i18n_local.get_prediction" :camel="true"
                  :loading="loadingPlaceDetails || loadingPricePrediction"
                  @mClick="getPrediction"/>
                  </b-col>
                </b-row>      
              </md-card-content>
            </md-card>
            <div id="powered-by">
              <span>Powered by</span> <img :src="poweredByLogo"/>
            </div>

          </b-col>
          <b-col xl="3" lg="1" md="2" sm="0" cols="0"/>
        </b-row>
      </div>

      <md-snackbar :md-active.sync="showSnackbar" md-persistent>
        <span>{{snackbarMessage}}</span>
      </md-snackbar>

      <md-dialog :md-active.sync="showPopupDialog" style="padding: 2em;">

        <p class="moow-header" style="padding-left:1em">{{i18n_local.results_on_email}}</p>
        <p class="moow-info-txt small">{{i18n_local.no_obligation}}</p>

                <b-row class="mt-5">
                  <b-col>

        <md-radio v-model="visitorType" value="tenant" >{{i18n_local.im_tenant}}</md-radio>
                  </b-col>
                  <b-col>
        <md-radio v-model="visitorType" value="landlord" >{{i18n_local.im_landlord}}</md-radio>

                  </b-col>
                </b-row>
        

        <md-field :class="{ 'md-invalid': visitorEmailErr }">
          <label>Enter email address</label>
          <md-input v-model="visitorEmail"></md-input>
          <span class="md-error">Required field</span>
          <span class="md-helper-text">{{helperText}}</span>
        </md-field>

        <b-row class="mt-5">
          <b-col style="text-align:center">
              <moow-button 
                :type="['dark']" 
                :btnText="i18n_local.get_prediction" 
                :camel="true"
                :loading="loadingPricePrediction"
                @mClick="createLeadAndGetPrediction"
              />
          </b-col>
        </b-row>
      </md-dialog>

      <md-dialog :md-active.sync="showPredictionDialog" class="scrolly-dialog moow-dialog moow-vert-scrollbar">
        <md-progress-bar v-if="loadingPricePrediction" class="md-primary" md-mode="indeterminate"></md-progress-bar>
        <!-- <div v-else-if="pricePredictionResponse" class="mb-3"> -->
        <div v-else-if="true" class="mb-3">
            <div v-if="!isLoggedIn" class="mb-3 ">
              <b-row>
                <b-col md="8" cols="12">
                  <p class="moow-info-txt">{{i18n_local.info.about_moow_3}}</p>
                  <p class="moow-info-txt">{{i18n_local.info.about_moow_cta}}</p>
                </b-col>
                <b-col md="4" cols="12" style="text-align: center">
                  <moow-button class="mb-2" :type="['light']" :camel="true" :btnText="i18n_local.ui.get_started" @mClick="getStarted()"/>
                  <moow-button :type="['link', 'dark']" :camel="true" :btnText="i18n_local.ui.learn_how" @mClick="goToLearnHow()"/>
                </b-col>
              </b-row>
            </div>

            <div style="text-align: center">
              <p v-if="!selectedDealTypeIsRent" class="moow-header large">{{selectedAddress}} {{i18n_local.info.estimated_asking_price}}</p>
              <p v-else class="moow-header large">{{selectedAddress}}  {{i18n_local.info.estimated_monthly_price}}</p>
              <p class="moow-header" >{{getPrice(pricePredictionResponse)}}€</p>
              <moow-button :type="['link', 'dark']" :camel="true" :btnText="i18n_local.doesnt_seem_right" @mClick="toggleReporting(true)"/>
            </div>
            <div v-if="showReportingDialog">

              <b-row>
                <b-col>
                   <md-field>
                    <label>{{i18n_local.suggested_price_min}}</label>
                    <md-input v-model="reportSuggestedPriceMin" type="number"></md-input>
                    <md-icon>euro_symbol</md-icon>
                  </md-field>
                </b-col>
                <b-col>
                  <md-field>
                    <label>{{i18n_local.suggested_price_max}}</label>
                    <md-input v-model="reportSuggestedPriceMax" type="number"></md-input>
                    <md-icon>euro_symbol</md-icon>
                  </md-field>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <md-field>
                    <label>{{i18n_local.comments}}</label>
                    <md-input v-model="reportComment"></md-input>
                    <span class="md-helper-text">{{i18n_local.val_report_help}}</span>
                  </md-field>
                </b-col>
              </b-row>
              <b-row class="mt-3 mb-3">
                <b-col>
                  <moow-button :type="['link']" :camel="true" btnText="cancel" @mClick="cancelReport()" />
                  <moow-button class="ml-2" :type="['dark']" :camel="true" btnText="submit" @mClick="submitReport()" :loading="!lastReportId" :disabled="disableSubmit"/>
                </b-col>
              </b-row>
            </div>
            <p class="moow-info-txt small"><i>{{i18n_local.info.estimation_disclaimer}}</i></p>

            <!-- <p class="moow-subheader mt-5">{{i18n_local.similar_properties}}</p>
            <p
              lg="12"
              v-for="(property, index) in getMaxSimilarProperties(pricePredictionResponse, 5)"
              :key="index"
            >
              <a
                :href="property.url"
                target="_blank"
              >{{property.street_name}} {{property.street_number}} at {{property.rent}}€</a>
            </p> -->
        </div>

        <md-dialog-actions>
          <moow-button :type="['dark', 'outlined', 'flat']" :camel="true" btnText="Close" @mClick="showPredictionDialog = false"/>
        </md-dialog-actions>
      </md-dialog>
    </b-container>
  </div>
</template>

<script>
let emptySelectedPlace = {
  address: {
    county: "",
    municipality: "",
    street: "",
    number: ""
  },
  geoCoords: [{ lat: undefined, lng: undefined }]
};
const lists = require("@/lists.js");
import { getPlacePredictions, getPlaceDetails } from "../../mapsRepository.js";
import { convertGoogPlaceDetailsToMoowLocation } from "../../utils/address/addressUtil.js";
import {
  getRentPrediction,
  getSalePrediction,
  attemptToSendPricePredictionOnEmail,
  createPriceRequestReport,
  updatePriceRequestReport
} from "../../pricing/services/pricingService.js";
import { buildRentPricingPredictionRequestRaw, buildPriceReportCommand, buildPriceReportUpdateCommand } from "../../pricing/factory/pricingFactory.js";
  import { getCurrentFirebaseUser } from "@/platform/auth/services/authService.js";
import { mapGetters } from "vuex";
import * as HubspotService from '../../services/hubspot';
import { AVAILABLE_EVENTS } from "@/third-party/firebase/services/firebaseService";
import { captureEvent } from "@/utils/reporting/reportingService.js";
import ToggleSwitch from "@/components/interface/buttons/toggleSwitch.vue";

export default {
  name: "pridePrediction",
  props:{
    client: {
      type: String,
      default: "moowle"
    }
  },
  components: {
    "toggle-switch": ToggleSwitch,
  },
  validator: null,
  data() {
    return {
      showPredictionDialog: false, // temp as true, otherwise false
      loading: false,
      showSnackbar: false,
      snackbarMessage: "",
      loadingPricePrediction: false,
      placesPredictions: [],
      selectedPlace: emptySelectedPlace,
      selected: "",
      loadingPlaceDetails: false,
      mapStartLocation: { lat: 59.0, lng: 24.0 },
      showPlaceDetails: false,
      apartmentArea: undefined,
      apartmentFloor: undefined,
      apartmentCondition: "",
      nrOfFloors: undefined,
      nrOfRooms: undefined,
      conditions: lists.conditionListLimited,
      balcony: false,
      parking: false,
      apartmentYear: undefined,
      pricePredictionResponse: "",
      pricePredictionErr: "",
      showPopupDialog: false,
      visitorType: "landlord",
      visitorEmail: "",
      visitorEmailErr: false,
      similarProperties: [],
      isMonthly: true,
      emailRule: /.+@.+/,
      addressErr: false,
      yearErr: false,
      areaErr: false,
      conditionErr: false,
      nrOfRoomsErr: false,
      floorNrErr: false,
      nrOfFloorsErr: false,
      gettingSalePrice: false,
      selectedDealTypeIsRent: true,
      pricingRequest: {},
      reportComment:"",
      reportSuggestedPrice: undefined,
      reportSuggestedPriceMin: undefined,
      reportSuggestedPriceMax: undefined,
      showReportingDialog: false,
      lastReportId: undefined,
      disableSubmit: false
    };
  },
  created() {
    this.$emit("emitCustomAction", {action:"hideSideMenu"})
    if (process.env.NODE_ENV == "development") {
      this.apartmentArea = 53;
      this.parking = true;
      this.balcony = true;
      this.nrOfRooms = 2;
      this.nrOfFloors = 5;
      this.apartmentFloor = 2;
      this.visitorEmail = "contact@moowle.com"
    }
    this.$emit("emitCustomAction", {action:"hideSideMenu"})
  },
  watch: {
    visitorEmail: function(val, oldVal) {
      if (val && val != oldVal) this.visitorEmailErr = false;
    },
    selected: function(val, oldVal) {
      if (val) this.addressErr = false;
    },
    apartmentYear: function(val, oldVal) {
      if (val) this.yearErr = false;
    },
    apartmentArea: function(val, oldVal) {
      if (val) this.areaErr = false;
    },
    apartmentCondition: function(val, oldVal) {
      if (val) this.conditionErr = false;
    },
    nrOfRooms: function(val, oldVal) {
      if (val) this.nrOfRoomsErr = false;
    },
    apartmentFloor: function(val, oldVal) {
      if (val) this.floorNrErr = false;
    },
    nrOfFloors: function(val, oldVal) {
      if (val) this.nrOfFloorsErr = false;
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    allCaps: function (value) {
      if (!value) return "";
      return value.toUpperCase();
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    termType() {
      if (this.isMonthly) return "Monthly rent";
      else return "Daily rent";
    },
    selectedAddress() {
      if (!this.selectedPlace) return "";
      else
        return (
          this.selectedPlace.address.street +
          " " +
          this.selectedPlace.address.number +
          ", " +
          this.selectedPlace.address.municipality +
          ", " +
          this.selectedPlace.address.country
        );
    },
    isLoggedIn() {
      var user = getCurrentFirebaseUser()
      if (user && !user.isAnonymous) return true;
      else return false;
    },
    dt() {
      // only for debug
      var locationFromStore = this.$store.getters.location;
      locationFromStore.address.country = "estonia";
      return locationFromStore;
    },
    labelLogo(){
      if(this.client === 'moowle')return require("../../assets/logos/main-logo-color.png");
      else if(this.client === 'uusmaa')return require("../../assets/logos/uusmaa-logo 1.svg");
    },
    helperText(){
      if(this.client === 'moowle')return this.i18n_local.valuation_email_help
      else if(this.client === 'uusmaa')return this.i18n_local.valuation_email_help_uus
    },
    labelCardStyle(){
      if(this.client === 'moowle') {
        return "border-top: 13px solid #E06968;"
      }
      else if(this.client === 'uusmaa') return "border-top: 13px solid #FFE000;"
    },
    poweredByLogo(){
      return require("../../assets/logos/moowle-logo-white.png");
    },
    getPriceTypeText(){
      if(this.selectedDealTypeIsRent) return this.i18n_local.rent
      else return this.i18n_local.sale
    },
    currentUserEmail(){
      if(this.$store.getters.user) return this.$store.getters.user.email;
    }
  },
  methods: {
    toggleReporting(show){
      this.showReportingDialog = show
    },
    async createUserRequest(){
      this.lastReportId = undefined // null out the report as new one will be made.

      let userEmail = this.visitorEmail
      let userIsLoggedIn = false
      if(this.currentUserEmail){
        userEmail = this.currentUserEmail
        userIsLoggedIn = true
      }
     
      const reportCommand = buildPriceReportCommand(
        this.pricingRequest,
        this.pricePredictionResponse,
        userEmail,
        this.visitorType,
        userIsLoggedIn,
        this.reportComment,
        {min: this.reportSuggestedPriceMin, max: this.reportSuggestedPriceMax}
      )
      this.lastReportId = await createPriceRequestReport(reportCommand)
    },
    cancelReport(){
        this.toggleReporting(false)
        this.reportComment =""
        this.reportSuggestedPriceMin = undefined
        this.reportSuggestedPriceMax = undefined
    },
    async submitReport(){
      try{
        this.disableSubmit=true
        if (!this.lastReportId) throw new Error("no last report id found, nothing to update")
        const update = buildPriceReportUpdateCommand({reportComment: this.reportComment, minSuggested:this.reportSuggestedPriceMin, maxSuggested: this.reportSuggestedPriceMax})

        this.toggleReporting(false)
        this.reportComment =""
        this.reportSuggestedPriceMin = undefined
        this.reportSuggestedPriceMax = undefined
        this.notifyUser(this.i18n_local.notifications.val_report_submitted);
        await updatePriceRequestReport(this.lastReportId, update)
      }catch(ex){
        console.log(ex)
      }finally{
        this.disableSubmit=false
      }
    },
    switchDealType(state){
      console.log("switchDealType > state:", state)
      this.selectedDealTypeIsRent = state
    },
    goToLearnHow(){
      window.open("https://moowle.com/how/", "_blank");
    },
    getStarted(){
      captureEvent({
        event: AVAILABLE_EVENTS.select_content,
        params: {
          content_type: "Button press",
          items: [{ id: "valuation_get_started", name: this.visitorEmail }]
        }
      });
      this.redirectTo({ where: 'login' })
    },
    getMaxSimilarProperties(pricePrediction, maxNr) {
      if(pricePrediction && pricePrediction.similarProperties) return pricePrediction.similarProperties.slice(0, maxNr);
      return ""
    },
    getPrice(pricePrediction) {
      const predictionValue = parseFloat(pricePrediction.price);
      const delta = (predictionValue * 5) / 100;
      var res = "";
      var min = predictionValue - delta;
      var max = predictionValue + delta;
      return min.toFixed(0) + " - " + max.toFixed(0);
    },
    async getPricePrediction() {
      try{
        this.loadingPricePrediction = true;
        this.showPredictionDialog = true;
        const requestBuilder = buildRentPricingPredictionRequestRaw(
          this.selectedPlace.geoCoords[0].lat,
          this.selectedPlace.geoCoords[0].lng,
          this.apartmentFloor,
          this.nrOfFloors,
          this.apartmentArea,
          this.apartmentCondition,
          this.parking,
          this.balcony,
          this.nrOfRooms,
          this.isMonthly,
          this.selectedPlace.placeId,
          null
        );
        if (!requestBuilder.success) throw requestBuilder.message
        else{
          this.pricingRequest = {request: requestBuilder.result, selectedPlace: this.selectedPlace}
          if(!this.selectedDealTypeIsRent) return await getSalePrediction(requestBuilder.result);
          else return await getRentPrediction(requestBuilder.result);
        } 
      }catch(ex){
        console.log('ex: ', ex);
        
        this.failPredictionQuery(
          "Pricing is currently not available"
        );
      } finally {
        this.loadingPricePrediction = false;
      }
    },
    async getPrediction() {
      if (this.validateForm()) {
        if (this.isLoggedIn){
          this.pricePredictionResponse = await this.getPricePrediction()          
          this.createUserRequest()
        } 
        else this.showPopupDialog = true;

        captureEvent({
          event: AVAILABLE_EVENTS.select_content,
          params: {
            content_type: "Button press",
            item_id: "valuation_get"
          }
        })
      } else {
        this.notifyUser("Missing required fields");
      }
    },
    async getPredictionFromDialog() {
      const result = await this.getPricePrediction()
      this.pricePredictionResponse = result
      this.createUserRequest()
      let similarProperties = this.getMaxSimilarProperties(this.pricePredictionResponse, 4)
      
      attemptToSendPricePredictionOnEmail(
        result,
        this.visitorEmail,
        this.selectedAddress,
        this.visitorType,
        this.selectedDealTypeIsRent,
        similarProperties,
        this.client
      );
      this.notifyUser("Valuation report was sent to your email");
      this.showPopupDialog = false;
    },
    async createLeadAndGetPrediction(){
      if (this.visitorEmail && this.emailRule.test(this.visitorEmail)) {
        this.createLead();
        this.getPredictionFromDialog();

        captureEvent({
          event: AVAILABLE_EVENTS.select_content,
          params: {
            content_type: "Button press",
            items: [{ id: "valuation_submit_lead", name: this.visitorEmail }]
          }
        });
      } else {
        this.visitorEmailErr = true;
      }
    },
    async createLead() {
        try {
            this.loadingPricePrediction = true;
            const { data: { result: { hubspotContactId } = {} } = {} } = await HubspotService.createContact({
                contactData: {
                    email: this.visitorEmail,
                    relationshipType: this.visitorType,
                },
                propertyData: this.getContactRelatedData(),
                client: this.client
            });
            if (!hubspotContactId) {
                console.log('Lead was not created');
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.loadingPricePrediction = false;
        }
    },
    getContactRelatedData() {
        return {
            address: this.resolveAddressString(),
            nrOfRooms: this.nrOfRooms,
            apartmentArea: this.apartmentArea,
            apartmentCondition: this.apartmentCondition,
            apartmentFloor: this.apartmentFloor,
            nrOfFloors: this.nrOfFloors,
            balcony: this.balcony,
            parking: this.parking,
        };
    },
    resolveAddressString() {
        const { address: { country, municipality, street, number } = {} } = this.selectedPlace;

        return `${street} ${number}, ${municipality}, ${country}`;
    },
    showDialog() {
      this.showPopupDialog = true;
    },
    validateForm() {
      let res = true;
      if (!this.apartmentArea) {
        this.areaErr = true;
        res = false;
      }

      if (!this.selectedPlace || (!this.selectedPlace.geoCoords[0].lat && !this.selectedPlace.placeId)) {
        this.addressErr = true;
        res = false;
      }

      if (!this.apartmentCondition) {
        this.conditionErr = true;
        res = false;
      }
      if (!this.nrOfRooms || this.nrOfRooms <= 0) {
        this.nrOfRoomsErr = true;
        res = false;
      }
      if (!this.nrOfFloors) {
        this.nrOfFloorsErr = true;
        res = false;
      }
      if (!this.apartmentFloor) {
        this.floorNrErr = true;
        res = false;
      }
      return res;
    },
    getPlacePredictions(searchTerm) {
      try {
        let searhTermForUrl = searchTerm.replace(new RegExp(" ", "g"), "+");
        this.placesPredictions = getPlacePredictions(searhTermForUrl, "address")
          .then(predictions => {
            return predictions;
          })
          .catch(err => {
            return [];
          });
      } catch (error) {}
    },
    async getPlaceDetails(item) {
      this.loadingPlaceDetails = true;
      this.showPlaceDetails = true;
      this.selected = item.description;
      let placeId = item.place_id;
      const details = await getPlaceDetails(placeId)
      this.selectedPlace = convertGoogPlaceDetailsToMoowLocation(
        details,
        placeId
      );
      this.mapStartLocation = this.selectedPlace.geoCoords[0];
      this.loadingPlaceDetails = false;
      this.disableNext = false;
    },
    notifyUser(msg) {
      this.showSnackbar = true;
      this.snackbarMessage = msg;
    },
    failPredictionQuery(message) {
      this.pricePredictionErr = message;
      this.showPredictionDialog = false;
      this.notifyUser(message);
      this.loadingPricePrediction = false;
    },
    redirectTo({ where, params, query }) {
      this.$router.push({
        name: where,
        params: params,
        query: query,
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/global.css";
@import "../../assets/styles/variables.scss";

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
.price-est-container {
  width: 100%;
  background-color: #1c77ac;
  color: white;
  font-weight: 500;
  font-size: 22px;
  padding: 10px;
  text-align: center;
  border-radius: 10px;
}

// .label-card{
//   border-top: 13px solid $old-makeup-pink;
// }

.label-logo{
  width: 130px;
  height: 32px;
}

#powered-by{
  text-align: right;
  font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 24px;
}
#powered-by span{
  color: white;
}

#powered-by img{
max-height: 14px;;
}
</style>



// WEBPACK FOOTER //
// src/components/pricing/PricePrediction.vue